module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "users row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('div', {
    staticClass: "control"
  }, [_c('div', {
    staticClass: "select"
  }, [_vm._v("\n                Zeige\n                "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.length),
      expression: "length"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.length = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.resetPagination()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("10")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "20"
    }
  }, [_vm._v("20")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "30"
    }
  }, [_vm._v("30")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "50"
    }
  }, [_vm._v("50")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "100"
    }
  }, [_vm._v("100")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1000000000"
    }
  }, [_vm._v("- ALLE -")])]), _vm._v("\n                Benutzer\n            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-offset-6 col-md-3"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.search),
      expression: "search"
    }],
    staticClass: "form-control pull-right",
    attrs: {
      "type": "text",
      "placeholder": "Suche..."
    },
    domProps: {
      "value": (_vm.search)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.search = $event.target.value
      }, function($event) {
        return _vm.resetPagination()
      }]
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12",
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_c('datatable', {
    attrs: {
      "columns": _vm.columns,
      "sortKey": _vm.sortKey,
      "sortOrders": _vm.sortOrders
    },
    on: {
      "sort": _vm.sortBy
    }
  }, [_c('tbody', [_vm._l((_vm.paginated), function(user) {
    return _c('tr', {
      key: user.id
    }, [_c('td', [_vm._v(_vm._s(user.companyname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.username))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.firstname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.lastname))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(user.usertype))]), _vm._v(" "), (user.globalstate.startsWith('red')) ? _c('td', [_c('span', {
      staticClass: "badge badge-danger"
    }, [_vm._v(_vm._s(_vm.trans('messages.invalid')))]), _vm._v("  " + _vm._s(_vm.userstate(user)) + " ")]) : (user.globalstate.startsWith('yellow')) ? _c('td', [_c('span', {
      staticClass: "badge badge-warning"
    }, [_vm._v(_vm._s(_vm.trans('messages.expiring')))])]) : _c('td', [_c('span', {
      staticClass: "badge badge-success"
    }, [_vm._v(_vm._s(_vm.trans('messages.valid')))])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('div', {
      staticClass: "btn-group"
    }, [_c('a', {
      staticClass: "btn btn-info btn-sm",
      attrs: {
        "href": '/manage/user/details/' + user.id,
        "title": _vm.trans('messages.details')
      }
    }, [_c('i', {
      staticClass: "fa fa-folder-open"
    })]), _vm._v(" "), _c('a', {
      staticClass: "btn btn-success btn-sm",
      attrs: {
        "href": "#",
        "title": _vm.trans('messages.password')
      },
      on: {
        "click": function($event) {
          return _vm.oneTimePassword(user.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-unlock-alt"
    })]), _vm._v(" "), _c('a', {
      staticClass: "btn btn-success btn-sm",
      attrs: {
        "disabled": user.globalstate.startsWith('green') || user.globalstate.startsWith('yellow'),
        "href": "#",
        "title": _vm.trans('messages.reminder_mail')
      },
      on: {
        "click": function($event) {
          return _vm.sendReminderMail(user.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-at"
    })]), _vm._v(" "), (_vm.permissions.includes('users.edit')) ? _c('a', {
      staticClass: "btn btn-warning btn-sm",
      attrs: {
        "href": '/manage/user/edit/' + user.id,
        "title": _vm.trans('messages.edit')
      }
    }, [_c('i', {
      staticClass: "fa fa-edit"
    })]) : _vm._e(), _vm._v(" "), (_vm.permissions.includes('users.delete')) ? _c('a', {
      staticClass: "btn btn-danger btn-sm confirm-delete",
      attrs: {
        "href": '/manage/user/delete/' + user.id,
        "data-user-id": user.id,
        "title": _vm.trans('messages.delete')
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })]) : _vm._e()])])])
  }), _vm._v(" "), _c('tr', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }]
  }, [_c('td', {
    attrs: {
      "colspan": "7",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.trans('messages.loading_data')))])]), _vm._v(" "), (_vm.pagination.total == 0 && _vm.loading == false) ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "7",
      "align": "center"
    }
  }, [_vm._v(_vm._s(_vm.trans('messages.no_data')))])]) : _vm._e()], 2)])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('pagination', {
    attrs: {
      "pagination": _vm.pagination,
      "client": true,
      "filtered": _vm.filteredUsers,
      "paginationlabel": "Benutzer"
    },
    on: {
      "prev": function($event) {
        --_vm.pagination.currentPage
      },
      "next": function($event) {
        ++_vm.pagination.currentPage
      }
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-420d4ca9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/Users.vue
// module id = 108
// module chunks = 0